// from resources/views/layouts/app.blade.php
export const appEnv = (window as any).AppEnv as string;

export const amplitudeDeviceId = (window as any).AmplitudeDeviceId as string;
